export default __webpack_public_path__ + "static/media/503.addd5d72.png";